<template>
  <div v-if="list.length > 0" class="ll-question-list">
    <p
      class="ll-question-list_title"
      :class="{red:iconColor === 'red',yellow:iconColor === 'yellow',blue:iconColor ==='blue',green:iconColor === 'green'}"
    >
      <i :class="leadingIcon" /> {{ $t(title) }} {{ $t('共{number}題',{number:list.length}) }}
    </p>
    <div class="ll-question-list_questions">
      <div
        v-for="(question,questionIndex) in list"
        :key="questionIndex"
        class="ll-question-list_question"
      >
        <ErrorChecklistQuestion
          v-if="!question.score && error&& question.score!==0"
          :error="error"
          :ques-num="question.questionCustomedIndex"
          :title="question.title"
          @error-click="$_onClick(question)"
        />
        <ChecklistQuestion002
          v-else
          :ocap-content="ocapContent"
          :upload-url="uploadUrl"
          :editable="editable"
          :hide-focus="hideFocus"
          :hide-subtitle="hideSubtitle"
          :annex="hasAnnex"
          :ques-result="quesResult"
          :title="question.title"
          :subtitle="question.subtitle"
          :ques-type="question.quesType"
          :remark="question.remark"
          :images="question.images"
          :attaches="question.attaches"
          :ocap-remark="question.ocapRemark"
          :ocap-attaches="question.ocapAttaches"
          :law-list="question.lawList"
          :ques-num="question.questionCustomedIndex"
          :text-label="textLabel"
          :content-icon="contentIcon"
          :has-bottom-btn="hasBottomBtn"
          :focus="question.focus"
          :control-limit-data="question.controlLimitData"
          :spec-limit-data="question.specLimitData"
          :score="question.score"
          :alert-text="question.alertText"
          :risk-signal="question.riskSignal"
          :botton-btn-text="bottonBtnText"
          :remark-validate-rule="remarkValidateRule"
          :is-all-drop-down="isAllDropDown"
          :uploadModule="uploadModule"
          :guidelineList="question.guidelineList"
          @bottom-btn-click="$_bottomBtnClick(question)"
          @law-click="$_onClickLaw($event)"
          @editable-btn-submit="$_editableBtnSubmit($event,question)"
          @guideline-click="$_onClickRelatedGuideline($event)"
        />
      </div>
    </div>
    <LlActPopup
      :is-loading="isLoading.lawPopup"
      :law-content="lawContent"
      :popup-active="isActive.lawPopup"
      @popup-close="$_onClosePopup('lawPopup')"
    />
    <LvPopupInfoArticle
      ref="LvPopupInfoArticle"
    />
  </div>
</template>
<script>
import S_article from "@/service/api/v1/article";
import H_guideline from '@/helpers/guideline';

export default {
  name: "LlQuestionListRiskSort",
  props: {
    remarkValidateRule: {
      type: Boolean,
      default: false,
    },
    ocapContent: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default() {
        return [
          {
            index: 5,
            score: null,
            focus: 1,
            title:
              "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
            subtitle: "建議題目",
            remark:
              "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
            attaches: ["attache", "eeewref.pdf"],
            images: ["image"],
            articles: [
              {
                last_version: {
                  no_text: "no2",
                },
                act_version: {
                  id: 100,
                  name: "ddd",
                },
              },
            ],
            riskSignal: [
              { name: "罰鍰", icon: "" },
              { name: "罰鍰", icon: "" },
            ],
            alertText: "風險：停廠停業、罰鍰",
          },
          {
            index: 1,
            score: 25,
            focus: 1,
            title:
              "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
            subtitle: "建議題目",
            remark:
              "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
            attaches: ["attache", "eeewref.pdf"],
            images: ["image"],
            articles: [
              {
                last_version: {
                  no_text: "no2",
                },
                act_version: {
                  id: 100,
                  name: "ddd",
                },
              },
            ],
            riskSignal: [
              { name: "罰鍰", icon: "" },
              { name: "罰鍰", icon: "" },
            ],
            alertText: "風險：停廠停業、罰鍰",
          },
        ];
      },
    },
    bottonBtnText: {
      type: String,
      default: "",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    leadingIcon: {
      type: String,
      default: "icon-info-filled",
    },
    iconColor: {
      type: String,
      default: "",
    },
    categoryTitle: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    contentIcon: {
      type: String,
      default: "",
    },
    quesResult: {
      type: Boolean,
      default: false,
    },
    hasDot: {
      type: Boolean,
      default: false,
    },
    hasAnnex: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
    errorIcon: {
      type: String,
      default: "",
    },
    hasBottomBtn: {
      type: Boolean,
      default: false,
    },
    hideFocus: {
      type: Boolean,
      default: false,
    },
    hideSubtitle: {
      type: Boolean,
      default: false,
    },
    unAnswer: {
      type: Boolean,
      default: false,
    },
    isAllDropDown: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    }
  },
  data() {
    return {
      isLoading: {
        lawPopup: false,
      },
      isActive: {
        lawPopup: false,
      },
      lawContent: {},
    }
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    }
  },
  methods: {
    $_editableBtnSubmit($event, question) {
      const editableContent = {};
      editableContent.images = $event.images;
      editableContent.remark = $event.remark;
      editableContent.questionId = question.id;
      this.$emit("editable-btn-submit", editableContent);
    },
    $_onClick(question) {
      this.$emit("error-click", question.id);
    },
    async $_onClickLaw($event) {
      this.lawContent = {};
      const {type, id, versionId} = $event;
      if (type === "act") {
        const url = this.$router.resolve({
            path: `/factory/${this._currentFactoryId}/act-content-main/${id}`,
          });
        window.open(url.href, "_blank");
      } else {
        this.$_onOpenPopup('lawPopup');
        this.isLoading.lawPopup = true;
        const article = await S_article.getLawContent(
          this._currentFactoryId,
          versionId,
        );
        this.lawContent = S_article.getLawData(article);
        this.isLoading.lawPopup = false;
      }
    },
    $_bottomBtnClick(question) {
      this.$emit("bottom-btn-click", question.id);
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    },
    async $_onClickRelatedGuideline($event) {
      await H_guideline.clickRelatedGuideline(this, $event);
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-question-list";
</style>